
    const productContainers = [...document.querySelectorAll('.carousel__container')];
    const nxtBtn = [...document.querySelectorAll('.carousel__button--right')];
    const preBtn = [...document.querySelectorAll('.carousel__button--left')];

    productContainers.forEach((item, i) => {
        nxtBtn[i].addEventListener('click', () => {
            scrollCarousel('RIGHT',item)
        })

        preBtn[i].addEventListener('click', () => {
            scrollCarousel('LEFT',item)
        })
    });

    function scrollCarousel(direction, item)
    {
        var visibleSpaceWidth = item.getBoundingClientRect().width;
        var reviewWidth = item.children[0].getBoundingClientRect().width;
        var reviewMarginLeft = 0;
        if(item.children.length > 1)
        {
            var style = window.getComputedStyle(item.children[1]);
            reviewMarginLeft = parseInt(style.marginLeft);
        }
        var totalDistanceFromLeft = item.scrollLeft;
        var reviewsFitCount = howManyReviewsCanFit(reviewWidth, visibleSpaceWidth);
        var remainingSpace = visibleSpaceWidth - (reviewsFitCount * (reviewWidth + reviewMarginLeft)); //kolik zbyde mista, kdyz zacnou z leveho okraje zacinat recenze
        var scrolledFromZero = totalDistanceFromLeft % (visibleSpaceWidth - remainingSpace); //pozice, kdy se uplne vlevo dostane review, ktera pri kliknuti na sipku nebyla 100% viditelna 

        if(direction == 'RIGHT')
        {
            var scrollOffsetRight = visibleSpaceWidth - remainingSpace - scrolledFromZero;
            item.scrollLeft += scrollOffsetRight;
        }else 
        {
            var scrollOffsetLeft = 0;

            if((scrolledFromZero % (reviewWidth+reviewMarginLeft)) == 0)
            {
                scrollOffsetLeft = reviewWidth+reviewMarginLeft;
            }else{
                scrollOffsetLeft = (scrolledFromZero % (reviewWidth+reviewMarginLeft));
            }

            if(reviewsFitCount > 1)
            {
                for (let index = 1; index < reviewsFitCount; index++) {
                    scrollOffsetLeft += (reviewWidth+reviewMarginLeft);
                }
            }

            item.scrollLeft -= scrollOffsetLeft;
        }

    }

    function howManyReviewsCanFit(reviewWidth, visibleSpaceWidth)
    {
        return reviewsFitCount = Math.floor(visibleSpaceWidth / reviewWidth);
    }